export default __webpack_public_path__ + "static/small-image-18-4be8e1d914d04a587efdc8df46ba32a6.png";